import { render, staticRenderFns } from "./TicketImage.vue?vue&type=template&id=298db847&scoped=true&"
import script from "./TicketImage.vue?vue&type=script&lang=js&"
export * from "./TicketImage.vue?vue&type=script&lang=js&"
import style0 from "./TicketImage.vue?vue&type=style&index=0&id=298db847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298db847",
  null
  
)

export default component.exports